export const posts = [
  {
    "slug": "remove-december-special-hours-2021-01-04",
    "title": "Take December special hours off the listing, January 4, 2021",
    "seoTitle": "January Google hours (law office, January 4, 2021)",
    "description": "January Google hours for a law office on January 4, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-01-04",
    "cta": "This week, look at the old holiday hours. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "January is underway. If Thursday in December is still marked closed, or a holiday banner is still the first thing on the site, fix that before you announce anything new.",
          "This January 4, 2021 note is for a law office. The check is January Google hours: the old holiday hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the old holiday hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the old holiday hours. In January 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The old holiday hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the old holiday hours before you add anything",
        "paragraphs": [
          "A mismatch on January Google hours is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare the old holiday hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set New Year hours before the week starts, December 28, 2020",
        "href": "/blog/new-year-hours-2021-2020-12-28"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "january-homepage-holiday-banner-2021-01-11",
    "title": "Retire the holiday banner on the homepage, January 11, 2021",
    "seoTitle": "Holiday banner on a homepage (retail shop, January 11, 2021)",
    "description": "Holiday banner on a homepage for a retail shop on January 11, 2021. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2021-01-11",
    "cta": "This week, look at the holiday banner. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A December offer still sitting in the header teaches people the site is stale. One January line about what you are booking now is enough.",
          "This January 11, 2021 note is for a retail shop. The check is holiday banner on a homepage: the holiday banner, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the holiday banner",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the holiday banner. In January 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The holiday banner on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the holiday banner before you add anything",
        "paragraphs": [
          "A mismatch on holiday banner on a homepage is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare the holiday banner. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Test the December gift card purchase, December 14, 2020",
        "href": "/blog/gift-cards-december-2020-12-14"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "gift-card-link-after-the-rush-2021-01-18",
    "title": "See whether the gift card link still works, January 18, 2021",
    "seoTitle": "Gift card link (contractor, January 18, 2021)",
    "description": "Gift card link for a contractor on January 18, 2021. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2021-01-18",
    "cta": "This week, look at the gift card link. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "People still try to redeem what they were given. Open the link on a phone and make sure it lands on a balance or a booking, not a dead page.",
          "This January 18, 2021 note is for a contractor. The check is gift card link: the gift card link, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the gift card link",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the gift card link. In January 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The gift card link on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the gift card link before you add anything",
        "paragraphs": [
          "A mismatch on gift card link is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare the gift card link. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Retire the holiday banner on the homepage, January 11, 2021",
        "href": "/blog/january-homepage-holiday-banner-2021-01-11"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "winter-closure-on-the-listing-2021-01-25",
    "title": "Say so if a winter day is actually closed, January 25, 2021",
    "seoTitle": "Winter closure hours (salon, January 25, 2021)",
    "description": "Winter closure hours for a salon on January 25, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-01-25",
    "cta": "This week, look at a weather closure. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If ice or a short staff day shut the door, the listing has to say that. A regular weekly schedule will still show you open.",
          "This January 25, 2021 note is for a salon. The check is winter closure hours: a weather closure, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a weather closure",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a weather closure. In January 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A weather closure on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a weather closure before you add anything",
        "paragraphs": [
          "A mismatch on winter closure hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare a weather closure. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Take December special hours off the listing, January 4, 2021",
        "href": "/blog/remove-december-special-hours-2021-01-04"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "valentine-offer-one-line-2021-02-01",
    "title": "Keep a Valentine offer to one line, February 1, 2021",
    "seoTitle": "Valentine's Day offer (clinic, February 1, 2021)",
    "description": "Valentine's Day offer for a clinic on February 1, 2021. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2021-02-01",
    "cta": "This week, look at one Valentine line. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you run a February offer, put it in one sentence with the date it ends. Do not rename the business around the holiday.",
          "This February 1, 2021 note is for a clinic. The check is Valentine's Day offer: one Valentine line, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at one Valentine line",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at one Valentine line. In February 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "One Valentine line on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix one Valentine line before you add anything",
        "paragraphs": [
          "A mismatch on Valentine's Day offer is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare one Valentine line. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "See whether the gift card link still works, January 18, 2021",
        "href": "/blog/gift-card-link-after-the-rush-2021-01-18"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "valentine-hours-2021-2021-02-08",
    "title": "Put Valentine's week hours and the offer in one place, February 8, 2021",
    "seoTitle": "Valentine's week hours (restaurant, February 8, 2021)",
    "description": "Valentine's week hours for a restaurant on February 8, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-02-08",
    "cta": "This week, look at Valentine's week. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If 2021 includes a Valentine offer or a fuller book, say the hours and the last day of the offer. Leave the business name alone.",
          "This February 8, 2021 note is for a restaurant. The check is Valentine's week hours: Valentine's week, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Valentine's week",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Valentine's week. In February 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Valentine's week on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Valentine's week before you add anything",
        "paragraphs": [
          "A mismatch on Valentine's week hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare Valentine's week. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Say so if a winter day is actually closed, January 25, 2021",
        "href": "/blog/winter-closure-on-the-listing-2021-01-25"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "after-valentine-takedown-2021-02-15",
    "title": "Take the February offer down when it ends, February 15, 2021",
    "seoTitle": "Expired Valentine offer (law office, February 15, 2021)",
    "description": "Expired Valentine offer for a law office on February 15, 2021. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2021-02-15",
    "cta": "This week, look at an offer that already ended. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The Monday after the holiday, the banner should be gone. An expired deal is a reason to doubt the hours too.",
          "This February 15, 2021 note is for a law office. The check is expired Valentine offer: an offer that already ended, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at an offer that already ended",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at an offer that already ended. In February 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "An offer that already ended on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix an offer that already ended before you add anything",
        "paragraphs": [
          "A mismatch on expired Valentine offer is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare an offer that already ended. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Keep a Valentine offer to one line, February 1, 2021",
        "href": "/blog/valentine-offer-one-line-2021-02-01"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "february-monday-holiday-2021-02-22",
    "title": "Set hours for the February Monday holiday, February 22, 2021",
    "seoTitle": "February holiday hours (retail shop, February 22, 2021)",
    "description": "February holiday hours for a retail shop on February 22, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-02-22",
    "cta": "This week, look at hours for a Monday holiday. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If the shop is closed for the Monday holiday, write it as a special hour. The weekly Monday schedule will not do that for you.",
          "This February 22, 2021 note is for a retail shop. The check is February holiday hours: hours for a Monday holiday, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at hours for a Monday holiday",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at hours for a Monday holiday. In February 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Hours for a Monday holiday on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix hours for a Monday holiday before you add anything",
        "paragraphs": [
          "A mismatch on February holiday hours is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare hours for a Monday holiday. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Put Valentine's week hours and the offer in one place, February 8, 2021",
        "href": "/blog/valentine-hours-2021-2021-02-08"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "spring-services-you-sell-2021-03-01",
    "title": "Lead with the work you are booking this spring, March 1, 2021",
    "seoTitle": "Spring services (contractor, March 1, 2021)",
    "description": "Spring services for a contractor on March 1, 2021. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2021-03-01",
    "cta": "This week, look at the work you are booking now. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "March is when the job mix changes. The first screen should name the work you want calls for this month.",
          "This March 1, 2021 note is for a contractor. The check is spring services: the work you are booking now, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the work you are booking now",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the work you are booking now. In March 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The work you are booking now on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the work you are booking now before you add anything",
        "paragraphs": [
          "A mismatch on spring services is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare the work you are booking now. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Take the February offer down when it ends, February 15, 2021",
        "href": "/blog/after-valentine-takedown-2021-02-15"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "daylight-photos-2021-03-08",
    "title": "Replace the cover photo as the light changes, March 8, 2021",
    "seoTitle": "Spring business photos (salon, March 8, 2021)",
    "description": "Spring business photos for a salon on March 8, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-03-08",
    "cta": "This week, look at a current cover photo. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A photo from a dark winter afternoon is no longer what the street looks like. Take one new photo of the real entrance.",
          "This March 8, 2021 note is for a salon. The check is spring business photos: a current cover photo, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a current cover photo",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a current cover photo. In March 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A current cover photo on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a current cover photo before you add anything",
        "paragraphs": [
          "A mismatch on spring business photos is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare a current cover photo. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set hours for the February Monday holiday, February 22, 2021",
        "href": "/blog/february-monday-holiday-2021-02-22"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "spring-break-hours-2021-03-15",
    "title": "Write spring-break hours if the week is different, March 15, 2021",
    "seoTitle": "Spring break hours (clinic, March 15, 2021)",
    "description": "Spring break hours for a clinic on March 15, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-03-15",
    "cta": "This week, look at hours during a school break. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you close, open late, or get a rush during the break, say so on the listing. A normal week template will not.",
          "This March 15, 2021 note is for a clinic. The check is spring break hours: hours during a school break, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at hours during a school break",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at hours during a school break. In March 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Hours during a school break on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix hours during a school break before you add anything",
        "paragraphs": [
          "A mismatch on spring break hours is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare hours during a school break. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Replace the cover photo as the light changes, March 8, 2021",
        "href": "/blog/daylight-photos-2021-03-08"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "march-holiday-monday-2021-03-22",
    "title": "Set hours if you close for a March Monday, March 22, 2021",
    "seoTitle": "March holiday hours (restaurant, March 22, 2021)",
    "description": "March holiday hours for a restaurant on March 22, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-03-22",
    "cta": "This week, look at a Monday you are closed. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A Monday closure that lives only on a paper sign is invisible to the map. Add it as a special hour.",
          "This March 22, 2021 note is for a restaurant. The check is March holiday hours: a Monday you are closed, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a Monday you are closed",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a Monday you are closed. In March 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A Monday you are closed on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a Monday you are closed before you add anything",
        "paragraphs": [
          "A mismatch on March holiday hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare a Monday you are closed. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write spring-break hours if the week is different, March 15, 2021",
        "href": "/blog/spring-break-hours-2021-03-15"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "easter-hours-2021-2021-03-29",
    "title": "Write Easter week hours as special hours, March 29, 2021",
    "seoTitle": "Easter week hours (law office, March 29, 2021)",
    "description": "Easter week hours for a law office on March 29, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-03-29",
    "cta": "This week, look at Easter week hours. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Easter week in 2021 is not a normal week. Mark the day you close, and leave the rest of the weekly schedule as the days you are open.",
          "This March 29, 2021 note is for a law office. The check is Easter week hours: Easter week hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Easter week hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Easter week hours. In March 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Easter week hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Easter week hours before you add anything",
        "paragraphs": [
          "A mismatch on Easter week hours is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare Easter week hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set hours if you close for a March Monday, March 22, 2021",
        "href": "/blog/march-holiday-monday-2021-03-22"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "easter-week-follow-up-2021-04-05",
    "title": "Put regular hours back after the spring holiday, April 5, 2021",
    "seoTitle": "Hours after a spring holiday (retail shop, April 5, 2021)",
    "description": "Hours after a spring holiday for a retail shop on April 5, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-04-05",
    "cta": "This week, look at hours after the holiday week. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The special closure should expire. If Monday still looks closed, people will not come.",
          "This April 5, 2021 note is for a retail shop. The check is hours after a spring holiday: hours after the holiday week, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at hours after the holiday week",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at hours after the holiday week. In April 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Hours after the holiday week on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix hours after the holiday week before you add anything",
        "paragraphs": [
          "A mismatch on hours after a spring holiday is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare hours after the holiday week. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write Easter week hours as special hours, March 29, 2021",
        "href": "/blog/easter-hours-2021-2021-03-29"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "april-showers-note-2021-04-12",
    "title": "Tell people how a rainy week changes arrival, April 12, 2021",
    "seoTitle": "Rainy week schedule (contractor, April 12, 2021)",
    "description": "Rainy week schedule for a contractor on April 12, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-04-12",
    "cta": "This week, look at arrival on a rainy week. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you still come out, say so. If you move the job, say how you will tell them. Silence reads as a no-show.",
          "This April 12, 2021 note is for a contractor. The check is rainy week schedule: arrival on a rainy week, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at arrival on a rainy week",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at arrival on a rainy week. In April 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Arrival on a rainy week on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix arrival on a rainy week before you add anything",
        "paragraphs": [
          "A mismatch on rainy week schedule is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare arrival on a rainy week. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Put regular hours back after the spring holiday, April 5, 2021",
        "href": "/blog/easter-week-follow-up-2021-04-05"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "outdoor-hours-2021-04-19",
    "title": "Publish outdoor seating or job hours separately, April 19, 2021",
    "seoTitle": "Outdoor hours (salon, April 19, 2021)",
    "description": "Outdoor hours for a salon on April 19, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-04-19",
    "cta": "This week, look at hours for the outdoor part of the business. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If the patio or the exterior crew stops earlier than the front door, write both. One schedule will be wrong for someone.",
          "This April 19, 2021 note is for a salon. The check is outdoor hours: hours for the outdoor part of the business, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at hours for the outdoor part of the business",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at hours for the outdoor part of the business. In April 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Hours for the outdoor part of the business on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix hours for the outdoor part of the business before you add anything",
        "paragraphs": [
          "A mismatch on outdoor hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare hours for the outdoor part of the business. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Tell people how a rainy week changes arrival, April 12, 2021",
        "href": "/blog/april-showers-note-2021-04-12"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "busy-season-inquiries-2021-04-26",
    "title": "Say how far out you are booking, April 26, 2021",
    "seoTitle": "How far out you are booked (clinic, April 26, 2021)",
    "description": "How far out you are booked for a clinic on April 26, 2021. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2021-04-26",
    "cta": "This week, look at the wait for an appointment. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "April calls ask 'how soon.' Put the real wait on the page. 'Call for availability' with no hint wastes the call.",
          "This April 26, 2021 note is for a clinic. The check is how far out you are booked: the wait for an appointment, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the wait for an appointment",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the wait for an appointment. In April 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The wait for an appointment on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the wait for an appointment before you add anything",
        "paragraphs": [
          "A mismatch on how far out you are booked is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare the wait for an appointment. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Lead with the work you are booking this spring, March 1, 2021",
        "href": "/blog/spring-services-you-sell-2021-03-01"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "mother-hours-2021-2021-05-03",
    "title": "Say how Mother's Day bookings work this year, May 3, 2021",
    "seoTitle": "Mother's Day bookings (restaurant, May 3, 2021)",
    "description": "Mother's Day bookings for a restaurant on May 3, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-05-03",
    "cta": "This week, look at Mother's Day bookings. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The week of Mother's Day in 2021 fills early for a lot of shops. Say whether you are taking reservations, walk-ins, or neither, and the hour you stop.",
          "This May 3, 2021 note is for a restaurant. The check is Mother's Day bookings: Mother's Day bookings, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Mother's Day bookings",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Mother's Day bookings. In May 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Mother's Day bookings on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Mother's Day bookings before you add anything",
        "paragraphs": [
          "A mismatch on Mother's Day bookings is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare Mother's Day bookings. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish outdoor seating or job hours separately, April 19, 2021",
        "href": "/blog/outdoor-hours-2021-04-19"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "graduation-hours-2021-05-10",
    "title": "Publish hours for graduation and ceremony weeks, May 10, 2021",
    "seoTitle": "Graduation week hours (law office, May 10, 2021)",
    "description": "Graduation week hours for a law office on May 10, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-05-10",
    "cta": "This week, look at hours during a ceremony week. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Schools let out in clumps. If you close or add a seating, write the special hours instead of hoping the weekly schedule is close enough.",
          "This May 10, 2021 note is for a law office. The check is graduation week hours: hours during a ceremony week, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at hours during a ceremony week",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at hours during a ceremony week. In May 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Hours during a ceremony week on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix hours during a ceremony week before you add anything",
        "paragraphs": [
          "A mismatch on graduation week hours is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare hours during a ceremony week. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Say how Mother's Day bookings work this year, May 3, 2021",
        "href": "/blog/mother-hours-2021-2021-05-03"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "summer-hiring-page-2021-05-17",
    "title": "Keep hiring off the customer homepage, May 17, 2021",
    "seoTitle": "Hiring versus the homepage (retail shop, May 17, 2021)",
    "description": "Hiring versus the homepage for a retail shop on May 17, 2021. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2021-05-17",
    "cta": "This week, look at where a job posting lives. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A help-wanted banner as the first thing on the site sends customers away. Put hiring on its own page and leave the phone for clients.",
          "This May 17, 2021 note is for a retail shop. The check is hiring versus the homepage: where a job posting lives, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at where a job posting lives",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at where a job posting lives. In May 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Where a job posting lives on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix where a job posting lives before you add anything",
        "paragraphs": [
          "A mismatch on hiring versus the homepage is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare where a job posting lives. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Say how far out you are booking, April 26, 2021",
        "href": "/blog/busy-season-inquiries-2021-04-26"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "may-service-list-2021-05-24",
    "title": "Edit the May service list down to what you can do, May 24, 2021",
    "seoTitle": "May service list (contractor, May 24, 2021)",
    "description": "May service list for a contractor on May 24, 2021. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2021-05-24",
    "cta": "This week, look at services you can do this month. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Take off anything booked out until fall or discontinued. A long list you cannot honor is a listing problem too.",
          "This May 24, 2021 note is for a contractor. The check is May service list: services you can do this month, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at services you can do this month",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at services you can do this month. In May 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Services you can do this month on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix services you can do this month before you add anything",
        "paragraphs": [
          "A mismatch on May service list is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare services you can do this month. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish the November menu or service list, November 30, 2020",
        "href": "/blog/november-menu-2020-11-30"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "memorial-hours-2021-2021-05-31",
    "title": "Mark Memorial Day on the listing, May 31, 2021",
    "seoTitle": "Memorial Day hours (salon, May 31, 2021)",
    "description": "Memorial Day hours for a salon on May 31, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-05-31",
    "cta": "This week, look at Memorial Day hours. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Memorial Day 2021 is a Monday. If you are closed, the weekly Monday hours will still look open unless you add a special hour.",
          "This May 31, 2021 note is for a salon. The check is Memorial Day hours: Memorial Day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Memorial Day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Memorial Day hours. In May 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Memorial Day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Memorial Day hours before you add anything",
        "paragraphs": [
          "A mismatch on Memorial Day hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare Memorial Day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish hours for graduation and ceremony weeks, May 10, 2021",
        "href": "/blog/graduation-hours-2021-05-10"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "summer-hours-begin-2021-06-07",
    "title": "Switch the listing to summer hours, June 7, 2021",
    "seoTitle": "Summer hours (clinic, June 7, 2021)",
    "description": "Summer hours for a clinic on June 7, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-06-07",
    "cta": "This week, look at the summer schedule. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If the door time changed for the season, change the weekly hours. Leaving spring hours up is how you miss the first hot week.",
          "This June 7, 2021 note is for a clinic. The check is summer hours: the summer schedule, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the summer schedule",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the summer schedule. In June 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The summer schedule on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the summer schedule before you add anything",
        "paragraphs": [
          "A mismatch on summer hours is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare the summer schedule. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Mark Memorial Day on the listing, May 31, 2021",
        "href": "/blog/memorial-hours-2021-2021-05-31"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "father-hours-2021-2021-06-14",
    "title": "Set Father's Day week hours and capacity, June 14, 2021",
    "seoTitle": "Father's Day hours (restaurant, June 14, 2021)",
    "description": "Father's Day hours for a restaurant on June 14, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-06-14",
    "cta": "This week, look at Father's Day week. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If Father's Day 2021 changes the book or the menu, put the hours and the limit on the listing. Take it down the next week.",
          "This June 14, 2021 note is for a restaurant. The check is Father's Day hours: Father's Day week, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Father's Day week",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Father's Day week. In June 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Father's Day week on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Father's Day week before you add anything",
        "paragraphs": [
          "A mismatch on Father's Day hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare Father's Day week. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Switch the listing to summer hours, June 7, 2021",
        "href": "/blog/summer-hours-begin-2021-06-07"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "core-web-vitals-arrive-2021-2021-06-21",
    "title": "Watch the page experience on a phone, June 21, 2021",
    "seoTitle": "Page experience on a phone (law office, June 21, 2021)",
    "description": "Page experience on a phone for a law office on June 21, 2021. What to check so the website and Google listing agree.",
    "section": "Site speed",
    "date": "2021-06-21",
    "cta": "This week, look at how the page behaves while it loads. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "In June 2021, loading and stability on a phone became part of how pages compete. For a local shop the practical test is still simple: open the page on cellular and see if the number is tappable before you get impatient.",
          "This June 21, 2021 note is for a law office. The check is page experience on a phone: how the page behaves while it loads, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at how the page behaves while it loads",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at how the page behaves while it loads. In June 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "How the page behaves while it loads on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix how the page behaves while it loads before you add anything",
        "paragraphs": [
          "A mismatch on page experience on a phone is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare how the page behaves while it loads. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Core Web Vitals for a Local Service Business",
        "href": "/blog/core-web-vitals-for-a-local-service-business"
      }
    ]
  },
  {
    "slug": "july4-hours-2021-2021-06-28",
    "title": "Write July 4 hours before the weekend, June 28, 2021",
    "seoTitle": "July 4 hours (retail shop, June 28, 2021)",
    "description": "July 4 hours for a retail shop on June 28, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-06-28",
    "cta": "This week, look at July 4 hours. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Set July 4, 2021 as a special hour if you close or shorten the day. Do it before the weekend, not after the first wrong visit.",
          "This June 28, 2021 note is for a retail shop. The check is July 4 hours: July 4 hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at July 4 hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at July 4 hours. In June 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "July 4 hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix July 4 hours before you add anything",
        "paragraphs": [
          "A mismatch on July 4 hours is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare July 4 hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set Father's Day week hours and capacity, June 14, 2021",
        "href": "/blog/father-hours-2021-2021-06-14"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "after-july-fourth-2021-07-05",
    "title": "Remove Independence Day hours when the week ends, July 5, 2021",
    "seoTitle": "Hours after July 4 (contractor, July 5, 2021)",
    "description": "Hours after July 4 for a contractor on July 5, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-07-05",
    "cta": "This week, look at hours once the holiday week ends. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The special close should not leak into the next week. Open the listing on the following Monday and read it.",
          "This July 5, 2021 note is for a contractor. The check is hours after July 4: hours once the holiday week ends, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at hours once the holiday week ends",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at hours once the holiday week ends. In July 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Hours once the holiday week ends on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix hours once the holiday week ends before you add anything",
        "paragraphs": [
          "A mismatch on hours after July 4 is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare hours once the holiday week ends. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write July 4 hours before the weekend, June 28, 2021",
        "href": "/blog/july4-hours-2021-2021-06-28"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "midsummer-hours-2021-07-12",
    "title": "Confirm midsummer hours against the door, July 12, 2021",
    "seoTitle": "Midsummer hours (salon, July 12, 2021)",
    "description": "Midsummer hours for a salon on July 12, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-07-12",
    "cta": "This week, look at hours in the middle of summer. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Walk the sign on the door and the listing in the same hour. They drift in July more than people expect.",
          "This July 12, 2021 note is for a salon. The check is midsummer hours: hours in the middle of summer, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at hours in the middle of summer",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at hours in the middle of summer. In July 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Hours in the middle of summer on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix hours in the middle of summer before you add anything",
        "paragraphs": [
          "A mismatch on midsummer hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare hours in the middle of summer. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Remove Independence Day hours when the week ends, July 5, 2021",
        "href": "/blog/after-july-fourth-2021-07-05"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "vacation-week-2021-07-19",
    "title": "Mark a vacation week as special hours, July 19, 2021",
    "seoTitle": "Vacation week hours (clinic, July 19, 2021)",
    "description": "Vacation week hours for a clinic on July 19, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-07-19",
    "cta": "This week, look at a week you are away. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A week away is not a normal week with hope. Mark it closed or shortened before someone drives over.",
          "This July 19, 2021 note is for a clinic. The check is vacation week hours: a week you are away, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a week you are away",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a week you are away. In July 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A week you are away on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a week you are away before you add anything",
        "paragraphs": [
          "A mismatch on vacation week hours is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare a week you are away. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Confirm midsummer hours against the door, July 12, 2021",
        "href": "/blog/midsummer-hours-2021-07-12"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "heat-schedule-2021-07-26",
    "title": "Publish the heat schedule you are actually using, July 26, 2021",
    "seoTitle": "Heat schedule (restaurant, July 26, 2021)",
    "description": "Heat schedule for a restaurant on July 26, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-07-26",
    "cta": "This week, look at the schedule you use in the heat. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Earlier starts and stopped afternoons need to be on the listing the week you start doing them.",
          "This July 26, 2021 note is for a restaurant. The check is heat schedule: the schedule you use in the heat, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the schedule you use in the heat",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the schedule you use in the heat. In July 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The schedule you use in the heat on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the schedule you use in the heat before you add anything",
        "paragraphs": [
          "A mismatch on heat schedule is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare the schedule you use in the heat. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Mark a vacation week as special hours, July 19, 2021",
        "href": "/blog/vacation-week-2021-07-19"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "fall-booking-open-2021-08-02",
    "title": "Open fall bookings on the page when you open them, August 2, 2021",
    "seoTitle": "Fall bookings (law office, August 2, 2021)",
    "description": "Fall bookings for a law office on August 2, 2021. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2021-08-02",
    "cta": "This week, look at when fall appointments open. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you are taking September dates, say so. A page that still says 'summer books are open' is a month behind.",
          "This August 2, 2021 note is for a law office. The check is fall bookings: when fall appointments open, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at when fall appointments open",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at when fall appointments open. In August 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "When fall appointments open on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix when fall appointments open before you add anything",
        "paragraphs": [
          "A mismatch on fall bookings is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare when fall appointments open. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Keep hiring off the customer homepage, May 17, 2021",
        "href": "/blog/summer-hiring-page-2021-05-17"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "august-photo-2021-08-09",
    "title": "Photograph the storefront in August, August 9, 2021",
    "seoTitle": "August storefront photo (retail shop, August 9, 2021)",
    "description": "August storefront photo for a retail shop on August 9, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-08-09",
    "cta": "This week, look at a storefront photo from this month. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Awnings, hours on the door, and the light are enough. People compare the photo to the building.",
          "This August 9, 2021 note is for a retail shop. The check is August storefront photo: a storefront photo from this month, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a storefront photo from this month",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a storefront photo from this month. In August 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A storefront photo from this month on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a storefront photo from this month before you add anything",
        "paragraphs": [
          "A mismatch on August storefront photo is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare a storefront photo from this month. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish the heat schedule you are actually using, July 26, 2021",
        "href": "/blog/heat-schedule-2021-07-26"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "school-hours-2021-2021-08-16",
    "title": "Publish back-to-school hours the week they start, August 16, 2021",
    "seoTitle": "Back-to-school hours (contractor, August 16, 2021)",
    "description": "Back-to-school hours for a contractor on August 16, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-08-16",
    "cta": "This week, look at back-to-school hours. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "School schedules in 2021 change the rush hour. Write the hours you will keep once classes start, on the listing and the page.",
          "This August 16, 2021 note is for a contractor. The check is back-to-school hours: back-to-school hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at back-to-school hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at back-to-school hours. In August 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Back-to-school hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix back-to-school hours before you add anything",
        "paragraphs": [
          "A mismatch on back-to-school hours is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare back-to-school hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Photograph the storefront in August, August 9, 2021",
        "href": "/blog/august-photo-2021-08-09"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "back-from-vacation-2021-08-23",
    "title": "Turn regular hours back on after vacation, August 23, 2021",
    "seoTitle": "Hours after vacation (salon, August 23, 2021)",
    "description": "Hours after vacation for a salon on August 23, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-08-23",
    "cta": "This week, look at hours once you are back. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The special closure should be gone the morning you reopen. Check it before the first customer does.",
          "This August 23, 2021 note is for a salon. The check is hours after vacation: hours once you are back, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at hours once you are back",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at hours once you are back. In August 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Hours once you are back on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix hours once you are back before you add anything",
        "paragraphs": [
          "A mismatch on hours after vacation is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare hours once you are back. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish back-to-school hours the week they start, August 16, 2021",
        "href": "/blog/school-hours-2021-2021-08-16"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "menu-into-fall-2021-08-30",
    "title": "Start the fall list when the kitchen or shop does, August 30, 2021",
    "seoTitle": "Fall menu (clinic, August 30, 2021)",
    "description": "Fall menu for a clinic on August 30, 2021. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2021-08-30",
    "cta": "This week, look at the list you are switching to. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Do not leave July's list up as the only list. Publish the one you can make this week.",
          "This August 30, 2021 note is for a clinic. The check is fall menu: the list you are switching to, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the list you are switching to",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the list you are switching to. In August 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The list you are switching to on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the list you are switching to before you add anything",
        "paragraphs": [
          "A mismatch on fall menu is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare the list you are switching to. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Edit the May service list down to what you can do, May 24, 2021",
        "href": "/blog/may-service-list-2021-05-24"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "labor-hours-2021-2021-09-06",
    "title": "Mark Labor Day closed if the door will be locked, September 6, 2021",
    "seoTitle": "Labor Day hours (restaurant, September 6, 2021)",
    "description": "Labor Day hours for a restaurant on September 6, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-09-06",
    "cta": "This week, look at Labor Day hours. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Labor Day 2021 is a Monday. Add the special hour. A description that mentions the holiday is not a substitute.",
          "This September 6, 2021 note is for a restaurant. The check is Labor Day hours: Labor Day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Labor Day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Labor Day hours. In September 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Labor Day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Labor Day hours before you add anything",
        "paragraphs": [
          "A mismatch on Labor Day hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare Labor Day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Turn regular hours back on after vacation, August 23, 2021",
        "href": "/blog/back-from-vacation-2021-08-23"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "after-school-hours-2021-09-13",
    "title": "State after-school hours if that is the rush, September 13, 2021",
    "seoTitle": "After-school hours (law office, September 13, 2021)",
    "description": "After-school hours for a law office on September 13, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-09-13",
    "cta": "This week, look at the after-school rush. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If the chairs or the tables fill at three, the listing can say when you can still take a walk-in, if you can.",
          "This September 13, 2021 note is for a law office. The check is after-school hours: the after-school rush, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the after-school rush",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the after-school rush. In September 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The after-school rush on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the after-school rush before you add anything",
        "paragraphs": [
          "A mismatch on after-school hours is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare the after-school rush. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Mark Labor Day closed if the door will be locked, September 6, 2021",
        "href": "/blog/labor-hours-2021-2021-09-06"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "fall-services-2021-09-20",
    "title": "Lead with the fall job, not the summer one, September 20, 2021",
    "seoTitle": "Fall services (retail shop, September 20, 2021)",
    "description": "Fall services for a retail shop on September 20, 2021. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2021-09-20",
    "cta": "This week, look at the job this season is for. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The first sentence should match the calls. Summer's lead is now in the way.",
          "This September 20, 2021 note is for a retail shop. The check is fall services: the job this season is for, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the job this season is for",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the job this season is for. In September 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The job this season is for on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the job this season is for before you add anything",
        "paragraphs": [
          "A mismatch on fall services is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare the job this season is for. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Open fall bookings on the page when you open them, August 2, 2021",
        "href": "/blog/fall-booking-open-2021-08-02"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "patio-closing-2021-09-27",
    "title": "Say the last day for outdoor seating or work, September 27, 2021",
    "seoTitle": "Last day for outdoor service (contractor, September 27, 2021)",
    "description": "Last day for outdoor service for a contractor on September 27, 2021. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2021-09-27",
    "cta": "This week, look at when outdoor service ends. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Give a date. 'While weather allows' is not something the listing can show.",
          "This September 27, 2021 note is for a contractor. The check is last day for outdoor service: when outdoor service ends, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at when outdoor service ends",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at when outdoor service ends. In September 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "When outdoor service ends on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix when outdoor service ends before you add anything",
        "paragraphs": [
          "A mismatch on last day for outdoor service is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare when outdoor service ends. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Lead with the fall job, not the summer one, September 20, 2021",
        "href": "/blog/fall-services-2021-09-20"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "event-night-hours-2021-10-04",
    "title": "Post the hours for a late event night, October 4, 2021",
    "seoTitle": "Event night hours (salon, October 4, 2021)",
    "description": "Event night hours for a salon on October 4, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-10-04",
    "cta": "This week, look at hours for a late night. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A later close for one night is a special hour plus a post. Do not change the whole week to match one evening.",
          "This October 4, 2021 note is for a salon. The check is event night hours: hours for a late night, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at hours for a late night",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at hours for a late night. In October 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Hours for a late night on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix hours for a late night before you add anything",
        "paragraphs": [
          "A mismatch on event night hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare hours for a late night. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "State after-school hours if that is the rush, September 13, 2021",
        "href": "/blog/after-school-hours-2021-09-13"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "seasonal-product-2021-10-11",
    "title": "Show the seasonal product you actually have, October 11, 2021",
    "seoTitle": "Seasonal product (clinic, October 11, 2021)",
    "description": "Seasonal product for a clinic on October 11, 2021. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2021-10-11",
    "cta": "This week, look at a product you have in stock. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If it can sell out, say what happens when it does. A page for an item you cannot get is a wasted visit.",
          "This October 11, 2021 note is for a clinic. The check is seasonal product: a product you have in stock, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a product you have in stock",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a product you have in stock. In October 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A product you have in stock on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a product you have in stock before you add anything",
        "paragraphs": [
          "A mismatch on seasonal product is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare a product you have in stock. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Say the last day for outdoor seating or work, September 27, 2021",
        "href": "/blog/patio-closing-2021-09-27"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "earlier-dusk-2021-10-18",
    "title": "Photograph the sign so it reads after dusk, October 18, 2021",
    "seoTitle": "Evening photo of the sign (restaurant, October 18, 2021)",
    "description": "Evening photo of the sign for a restaurant on October 18, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-10-18",
    "cta": "This week, look at whether the sign can be read at dusk. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "October evenings start during business hours. A photo of a dark front is a reason to drive past.",
          "This October 18, 2021 note is for a restaurant. The check is evening photo of the sign: whether the sign can be read at dusk, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at whether the sign can be read at dusk",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at whether the sign can be read at dusk. In October 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Whether the sign can be read at dusk on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix whether the sign can be read at dusk before you add anything",
        "paragraphs": [
          "A mismatch on evening photo of the sign is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare whether the sign can be read at dusk. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Post the hours for a late event night, October 4, 2021",
        "href": "/blog/event-night-hours-2021-10-04"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "halloween-hours-2021-2021-10-25",
    "title": "Publish Halloween day hours, October 25, 2021",
    "seoTitle": "Halloween hours (law office, October 25, 2021)",
    "description": "Halloween hours for a law office on October 25, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-10-25",
    "cta": "This week, look at Halloween day hours. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Halloween 2021 often means an earlier close or a later door. Write the day itself, not a vague seasonal note.",
          "This October 25, 2021 note is for a law office. The check is Halloween hours: Halloween day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Halloween day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Halloween day hours. In October 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Halloween day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Halloween day hours before you add anything",
        "paragraphs": [
          "A mismatch on Halloween hours is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare Halloween day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Photograph the sign so it reads after dusk, October 18, 2021",
        "href": "/blog/earlier-dusk-2021-10-18"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "gift-page-2021-11-01",
    "title": "Give gifts their own short page, November 1, 2021",
    "seoTitle": "Holiday gift page (retail shop, November 1, 2021)",
    "description": "Holiday gift page for a retail shop on November 1, 2021. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2021-11-01",
    "cta": "This week, look at a page for gifts. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "What it is, what it costs or how it is redeemed, and how to buy it. Do not bury that under a December story.",
          "This November 1, 2021 note is for a retail shop. The check is holiday gift page: a page for gifts, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a page for gifts",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a page for gifts. In November 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A page for gifts on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a page for gifts before you add anything",
        "paragraphs": [
          "A mismatch on holiday gift page is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare a page for gifts. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Show the seasonal product you actually have, October 11, 2021",
        "href": "/blog/seasonal-product-2021-10-11"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "veterans-hours-2021-2021-11-08",
    "title": "Set Veterans Day hours if you close, November 8, 2021",
    "seoTitle": "Veterans Day hours (contractor, November 8, 2021)",
    "description": "Veterans Day hours for a contractor on November 8, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-11-08",
    "cta": "This week, look at Veterans Day hours. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you close or shorten Veterans Day 2021, write that day on the listing. The weekly schedule does not know the holiday.",
          "This November 8, 2021 note is for a contractor. The check is Veterans Day hours: Veterans Day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Veterans Day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Veterans Day hours. In November 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Veterans Day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Veterans Day hours before you add anything",
        "paragraphs": [
          "A mismatch on Veterans Day hours is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare Veterans Day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish Halloween day hours, October 25, 2021",
        "href": "/blog/halloween-hours-2021-2021-10-25"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "google-business-profile-name-2021-2021-11-15",
    "title": "The listing is now called Google Business Profile, November 15, 2021",
    "seoTitle": "Google Business Profile (salon, November 15, 2021)",
    "description": "Google Business Profile for a salon on November 15, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-11-15",
    "cta": "This week, look at the listing, under its current name. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "In November 2021 Google My Business became Google Business Profile. The name on the product changed. The job did not: hours, phone, and photos still have to match the door.",
          "This November 15, 2021 note is for a salon. The check is Google Business Profile: the listing, under its current name, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the listing, under its current name",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the listing, under its current name. In November 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The listing, under its current name on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the listing, under its current name before you add anything",
        "paragraphs": [
          "A mismatch on Google Business Profile is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare the listing, under its current name. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set Veterans Day hours if you close, November 8, 2021",
        "href": "/blog/veterans-hours-2021-2021-11-08"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "thanksgiving-hours-2021-2021-11-22",
    "title": "Write Thanksgiving week hours before Monday, November 22, 2021",
    "seoTitle": "Thanksgiving hours (clinic, November 22, 2021)",
    "description": "Thanksgiving hours for a clinic on November 22, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-11-22",
    "cta": "This week, look at Thanksgiving week hours. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Put Thanksgiving 2021 on special hours in Google Business Profile, and mirror them on the contact page.",
          "This November 22, 2021 note is for a clinic. The check is Thanksgiving hours: Thanksgiving week hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Thanksgiving week hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Thanksgiving week hours. In November 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Thanksgiving week hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Thanksgiving week hours before you add anything",
        "paragraphs": [
          "A mismatch on Thanksgiving hours is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare Thanksgiving week hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "The listing is now called Google Business Profile, November 15, 2021",
        "href": "/blog/google-business-profile-name-2021-2021-11-15"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "monday-after-thanksgiving-2021-11-29",
    "title": "Set hours for the Monday after Thanksgiving, November 29, 2021",
    "seoTitle": "Monday after Thanksgiving hours (restaurant, November 29, 2021)",
    "description": "Monday after Thanksgiving hours for a restaurant on November 29, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-11-29",
    "cta": "This week, look at the Monday after the holiday. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "That Monday is often shortened or closed and often forgotten on the listing. Write it before the weekend.",
          "This November 29, 2021 note is for a restaurant. The check is Monday after Thanksgiving hours: the Monday after the holiday, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the Monday after the holiday",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the Monday after the holiday. In November 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The Monday after the holiday on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the Monday after the holiday before you add anything",
        "paragraphs": [
          "A mismatch on Monday after Thanksgiving hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare the Monday after the holiday. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write Thanksgiving week hours before Monday, November 22, 2021",
        "href": "/blog/thanksgiving-hours-2021-2021-11-22"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "pickup-cutoff-2021-12-06",
    "title": "Publish the last day for pickup or delivery promises, December 6, 2021",
    "seoTitle": "Pickup cutoff (law office, December 6, 2021)",
    "description": "Pickup cutoff for a law office on December 6, 2021. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2021-12-06",
    "cta": "This week, look at the last day you can promise. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Say the date after which you cannot promise the holiday. Update it if you sell out sooner.",
          "This December 6, 2021 note is for a law office. The check is pickup cutoff: the last day you can promise, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the last day you can promise",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the last day you can promise. In December 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The last day you can promise on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the last day you can promise before you add anything",
        "paragraphs": [
          "A mismatch on pickup cutoff is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare the last day you can promise. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Give gifts their own short page, November 1, 2021",
        "href": "/blog/gift-page-2021-11-01"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "party-bookings-2021-12-13",
    "title": "Explain December party bookings, December 13, 2021",
    "seoTitle": "December party booking (retail shop, December 13, 2021)",
    "description": "December party booking for a retail shop on December 13, 2021. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2021-12-13",
    "cta": "This week, look at how a December party is booked. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Headcount, deposit, and the last day to reserve. If the month is full, say full.",
          "This December 13, 2021 note is for a retail shop. The check is December party booking: how a December party is booked, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at how a December party is booked",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at how a December party is booked. In December 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "How a December party is booked on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix how a December party is booked before you add anything",
        "paragraphs": [
          "A mismatch on December party booking is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare how a December party is booked. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish the last day for pickup or delivery promises, December 6, 2021",
        "href": "/blog/pickup-cutoff-2021-12-06"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "christmas-hours-2021-2021-12-20",
    "title": "Separate Christmas Eve, Christmas Day, and the days after, December 20, 2021",
    "seoTitle": "Christmas hours (contractor, December 20, 2021)",
    "description": "Christmas hours for a contractor on December 20, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-12-20",
    "cta": "This week, look at Christmas week hours. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Write Christmas Eve, Christmas Day, and the day you reopen for 2021. One line that says \"closed for the holidays\" is not a schedule.",
          "This December 20, 2021 note is for a contractor. The check is Christmas hours: Christmas week hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Christmas week hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Christmas week hours. In December 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Christmas week hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Christmas week hours before you add anything",
        "paragraphs": [
          "A mismatch on Christmas hours is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare Christmas week hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set hours for the Monday after Thanksgiving, November 29, 2021",
        "href": "/blog/monday-after-thanksgiving-2021-11-29"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "new-year-hours-2022-2021-12-27",
    "title": "Set New Year hours before the week starts, December 27, 2021",
    "seoTitle": "New Year hours (salon, December 27, 2021)",
    "description": "New Year hours for a salon on December 27, 2021. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2021-12-27",
    "cta": "This week, look at New Year hours. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Write New Year hours on the profile and the contact page for 2022. Check them on a phone, because that is where people look the night before.",
          "This December 27, 2021 note is for a salon. The check is New Year hours: New Year hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at New Year hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at New Year hours. In December 2021 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "New Year hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix New Year hours before you add anything",
        "paragraphs": [
          "A mismatch on New Year hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare New Year hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2021 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Separate Christmas Eve, Christmas Day, and the days after, December 20, 2021",
        "href": "/blog/christmas-hours-2021-2021-12-20"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  }
];
